import { Component, Input, OnInit } from "@angular/core";
import { MapHelperService } from "src/services/map-helper.service";
import { BaseMapService } from "../../services/BaseMap.service";
import { CallBackService } from "src/app/features/pages/callback/services/CallBack.service";
import { PanelExternalLayerService } from "src/app/features/map-features/sections/locations-section/services/Panel-External-Layer.service";
import { InfoBoxMapService } from "src/services/maps/features/InfoBox-Map.service";
@Component({
  selector: "map",
  templateUrl: "./map.component.html",
  styleUrls: ["./map.component.css"],
})
export class MapComponent implements OnInit {
  @Input() $Items: any = [];
  @Input() mapName: string = "";
  
  private _CENTER_LAT = "24.226252";
  private _CENTER_LNG = "-103.0266765";
  private _CENTER_ZOOM = "4.5";
  
  constructor(
    private baseMapService: BaseMapService, 
    private mapHelperService: MapHelperService, 
    private panelExternalLayerService: PanelExternalLayerService, 
    private callbackService: CallBackService,
    private infoBoxMapService: InfoBoxMapService) {}

  ngOnInit() {
    // Crear base
    this.baseMapService.createBaseMap(
      parseFloat(this._CENTER_LAT),
      parseFloat(this._CENTER_LNG),
      parseFloat(this._CENTER_ZOOM)
    );

    this.initialiceMapComponents();
  }
  
  ngOnDestroy(): void {
    this.panelExternalLayerService.capas = [];
    this.mapHelperService.removeMap(this.mapName);
  }

  initialiceMapComponents(){
    const isPresentationMode = false;
    this.baseMapService.addEventOnMapLoad(async () => {
      await this.callbackService.isNeededCallback();
      
      await this.baseMapService.loadMapIcons();

      // this.locationsMapService.LoadMapLocations();
      // this.valetParkingMapService.LoadMapValetParking();

      // this.geofencesMapService.LoadMapGeofences();
      // this.routeMapService.LoadRouteMap();

      this.infoBoxMapService.loadInfoBox();

      this.baseMapService.turnOffTrafficLayer();

      this.baseMapService.setMapSourcesAsReady(this.mapName);

      if (isPresentationMode) {
        this.baseMapService.startPresentationMode();
      }

      // this.baseMapService.notifyMapReady();
    });

    this.baseMapService.addMapStyleLoadVerifier(this.mapName);
  }
 
}
